
export enum TabIndex {
    LayYKien, CongBo, LuuTru
}
export enum TabIndexYKien {
    DanhSach, NoiDung
}

export type infoSearchYKien = {
    maTenDA?: string,
    chuDT?: string,
    thoigianFrom?: Date,
    thoigianTo?: Date,
    objectId?: number
}
export type trangThai = {
    objectId: number,

}
